<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">   
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item style="width:13%">
          	  <el-select v-model="query.tempid" clearable remote  filterable placeholder="请选择模板" @change="ischange=true">
	          	  <el-option v-for="(item,index) in templists" :label="item.name" :value="item.id" :key="index"></el-option>
	          </el-select>          
          </el-form-item>
		  <el-form-item style="width:15%">
	          <el-select v-model="query.brandid" filterable clearable placeholder="按品牌" @change="ischange=true">	          
			  	  <el-option label="不分品牌" value="0"></el-option>
              	  <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
              	  	  <span style="float: left">{{item.name}}</span>
      				  <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
              	  </el-option>
			  </el-select>
	      </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="gettempbrands">查询</el-button>
              <el-button type="danger" icon="el-icon-plus" @click="add">新增品牌图片</el-button>
          </el-form-item>   
      </el-form>
      
      <!-------------  广告管理信息列表  -------------->
      <div class="backborder2" style="margin-top:10px">
	      <el-table :data="brandtemplists" v-loading="listsLoading">
	      	  <el-table-column label="展示图">
	      	  	  <template slot-scope="scope">
	      	  	  	  <img :src="scope.row.thumb" style="width:35%;border-radius:5px;border:1px solid #ddd"/>
	      	  	  </template>
	      	  </el-table-column>
			  <el-table-column label="对应品牌" prop="brandname" align="left" width="180"></el-table-column>
			  <el-table-column label="模板名称" prop="tempname" align="left" width="180"></el-table-column>
			  <el-table-column label="建议尺寸" prop="size" width="180" align="center"></el-table-column>
			  <el-table-column label="新增时间" prop="inputtime" width="180" align="center"></el-table-column>
			  <el-table-column label="操作" width="180" align="center">
			  	  <template slot-scope="scope">
			          <el-button type="warning" size="mini" icon="el-icon-edit" circle @click="edit(scope.row)"></el-button>
					  <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="del(scope.row)"></el-button>
			      </template>
			  </el-table-column>
	      </el-table>
	      <div class="block">
	          <!--分页begin-->
	          <el-pagination
	              @size-change="pageSizeChange"
	              @current-change="pageCurrentChange"
	              :current-page="query.p"
	              :page-sizes="[10, 20, 50]"
	              :page-size="query.rollpage"
	              layout="total, sizes, prev, pager, next, jumper"
	              :total="total_rows">
	          </el-pagination>
	          <!--分页end-->
	      </div>
      </div>

	  <!-- 新增品牌图片信息 -->
	  <el-dialog title="新增品牌图片" :visible.sync="addphotoDialog" width="30%" top="5vh">
	  	  <el-form :inline="true" class="demo-form-inline" size="small">
			  <el-form-item style="width:45%">
				  <el-select v-model="addphoto.tempid" clearable remote  filterable placeholder="请选择模板" style="width:100%" @change="getsize">
	          	  	  <el-option v-for="(item,index) in templists" :label="item.name" :value="item.id" :key="index"></el-option>
	          	  </el-select>    
			  </el-form-item>
			  <el-form-item style="width:45%">
				  <el-select v-model="addphoto.brandid" filterable clearable placeholder="按品牌" style="width:100%">	          
					  <el-option label="不分品牌" value="0"></el-option>
					  <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
						  <span style="float: left">{{item.name}}</span>
						  <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
					  </el-option>
				  </el-select>
	      	  </el-form-item>
			  
			  <el-form-item>
			  	  <el-col :span="23">
					 <el-col :span="7">
					 	 <input @change="filecreateminiChange($event,'create')" type="file" style="height:2rem;position:absolute;filter:alpha(Opacity=0);-moz-opacity:0;opacity: 0;">
					 	 <el-button type="primary" size="mini">上传图片</el-button>
					 </el-col>
					 <el-col :span="13">
					    <el-tag type="danger" size="mini">温馨提示：请上传图片的大小不要超过200k</el-tag>
					 </el-col>
				  </el-col>
				  <el-col :span="23" style="font-size:.4rem">{{size}}</el-col>
				  <el-col :span="23" style="margin-top:10px">
	              	  <img :src="addphoto.showthumb" v-if="addphoto.thumb!='' && addphoto.thumb!=null" style="width:100%;border:1px solid rgb(221,221,221,.7);border-radius:5px;background:rgb(221,221,221,.7)">
	              	  <img src="../../assets/default_img.png" style="width:100%" v-if="addphoto.thumb=='' || addphoto.thumb==null">
				  </el-col>
			  </el-form-item>
		  </el-form>
		  <div class="block" style="text-align:right">
      	  	  <el-button @click="addphotoDialog=false" size="small">取消</el-button>
	          <el-button type="primary" :loading="updateLoading" @click="addtemp" size="small">保存</el-button>
      	  </div>
      </el-dialog>


	  <!-- 编辑品牌图片信息 -->
	  <el-dialog title="编辑品牌图片" :visible.sync="updateDialog" width="30%" top="5vh">
	  	  <el-form :inline="true" class="demo-form-inline" size="small">
			  <el-form-item style="width:45%">
				  <el-select v-model="updatephoto.tempid" clearable remote disabled  filterable placeholder="请选择模板" style="width:100%" @change="getsize">
	          	  	  <el-option v-for="(item,index) in templists" :label="item.name" :value="item.id" :key="index"></el-option>
	          	  </el-select>    
			  </el-form-item>
			  <el-form-item style="width:45%">
				  <el-select v-model="updatephoto.brandid" filterable disabled clearable placeholder="按品牌" style="width:100%">	          
					  <el-option label="不分品牌" value="0"></el-option>
					  <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
						  <span style="float: left">{{item.name}}</span>
						  <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
					  </el-option>
				  </el-select>
	      	  </el-form-item>
			  
			  <el-form-item>
			  	  <el-col :span="23">
					 <el-col :span="7">
					 	 <input @change="filecreateminiChange($event,'update')" type="file" style="height:2rem;position:absolute;filter:alpha(Opacity=0);-moz-opacity:0;opacity: 0;">
					 	 <el-button type="primary" size="mini">上传图片</el-button>
					 </el-col>
					 <el-col :span="13">
					    <el-tag type="danger" size="mini">温馨提示：请上传图片的大小不要超过200k</el-tag>
					 </el-col>
				  </el-col>
				  <el-col :span="23" style="font-size:.4rem">{{size}}</el-col>
				  <el-col :span="23" style="margin-top:10px">
	              	  <img :src="updatephoto.showthumb" v-if="updatephoto.thumb!='' && updatephoto.thumb!=null" style="width:100%;border:1px solid rgb(221,221,221,.7);border-radius:5px;background:rgb(221,221,221,.7)">
	              	  <img src="../../assets/default_img.png" style="width:100%" v-if="updatephoto.thumb=='' || updatephoto.thumb==null">
				  </el-col>
			  </el-form-item>
		  </el-form>
		  <div class="block" style="text-align:right">
      	  	  <el-button @click="updateDialog=false" size="small">取消</el-button>
	          <el-button type="primary" @click="updatetemp" size="small">保存</el-button>
      	  </div>
      </el-dialog>

          	 
  </div>
  </transition>  
</template>

<script>

export default {
 
  data () {
    return {
        url:this.GLOBAL.domain+"Brand/index",
        transitionshow:true,
        actionauth:'', //功能权限
        brandlists:[],
        lists:[],
        total_rows: 0,
        listsLoading:false,
        templists:[],
		brandlists:[],
		brandquery: {
	  	  act:'lists',
		  token:this.$cookies.get('token'),
		  rollpage:100000
	    },
        query: {
			act:'gettempbrands',
			token:this.$cookies.get('token'),
			tempid:'',
			brandid:'',
			p:1,
			rollpage:10
		},
        addphoto: {
			act:'addtempbrands',
			token:this.$cookies.get('token'),
			tempid:'',
			brandid:'',
			thumb:'',
			showthumb:'',
		},
		updatephoto: {
			act:'updatetempbrands',
			token:this.$cookies.get('token'),
			id:'',
			tempid:'',
			brandid:'',
			thumb:'',
			showthumb:'',
		},
		updateDialog:false,
		addphotoDialog:false,
		addphotoLoading:false,
        size:'',
		total_rows:0,
		listsLoading:false,
		brandtemplists:[],
		ischange:false,
      
    }
  },
    
  mounted(){  
    this.getactionauth();
	this.gettemps(); //获取模板信息
	this.getBrand(); //获取品牌信息
	this.gettempbrands(); //获取品牌模板详情信息
  },
  
  methods:{
    /** 重置表单 **/
    reset() {
        this.$refs.create.resetFields();
    },
    
    //获取功能权限
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },

	//获取品牌模板详情信息
	gettempbrands() {
		if(this.ischange==true) {
			this.query.p=1;
			this.query.rollpage=10;
		}

		this.listsLoading=true;
		var resource = this.$resource(this.url);
		resource.query(this.query).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.listsLoading=false;
			}else{
				var _this=this;
				this.brandtemplists = JSON.parse(Base64.decode(res.data.Data));
				this.brandtemplists.forEach(function(item,i) {
					_this.brandtemplists[i].thumb=_this.GLOBAL.staticUrl+item.thumb;
				});

				this.total_rows=parseInt(res.data.count);
				this.listsLoading=false;
				if(this.ischange) this.ischange=false;
			}
		}).catch((res) => {
			this.$message.error(this.GLOBAL.errortext);
			this.listsLoading=false;
		});
	},

	pageSizeChange(val) {
        this.query.rollpage = val;
        this.gettempbrands();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.gettempbrands();
    },
    
    //获取品牌模板信息
	gettemps() {
    	var resource = this.$resource(this.url);
		resource.query({ act:'gettemplists',token:this.$cookies.get('token')}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
			}else{
				this.templists = JSON.parse(Base64.decode(res.data.Data));
				//this.total_rows=parseInt(res.data.count);
			}
		}).catch((res) => {
			this.$message.error(this.GLOBAL.errortext);
		});
	},

	//获取品牌
	getBrand(){
	    var resource = this.$resource(this.GLOBAL.domain+"Brand/index");		    
	    resource.query(this.brandquery).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
			}else{
			    this.brandlists = JSON.parse(Base64.decode(res.data.Data));
			}
	    }).catch((res) => {
	          	
	    });
	},

	//添加品牌信息
	add() {
		this.addphotoDialog=true;
		this.addphoto.tempid='';
		this.addphoto.brandid='';
		this.addphoto.thumb='';
		this.addphoto.showthumb='';
		this.size='';
	},

	/** 获取模板建议尺寸 **/
    getsize() {
		var _this=this;
		var name='';
		if(this.addphoto.tempid=='') this.size='';
		this.templists.forEach(function(item,i) {
			if(item.id==_this.addphoto.tempid) name="建议上传图片尺寸："+item.size;
		});
		this.size=name;
	},
    
	/** 上传品牌图片信息 **/
	filecreateminiChange(el,type) {
		var resource = this.$resource(this.GLOBAL.uploadUrl);
    	var formData = new FormData();
    	formData.append('file', el.target.files[0]);
		formData.append('sys_type', 'cz');
		formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
    	resource.save(formData).then((res) => {
	    	var data=JSON.parse(Base64.decode(res.body.Data));
	        if(data.Result > 0) {
	            this.$message.error(data.msg);
	        }else {
	        	if(type=='create') {
	        		this.addphoto.showthumb=this.GLOBAL.staticUrl+data.imgsrc;
	            	this.addphoto.thumb=data.imgsrc;
	        	}else {
	        		this.updatephoto.showthumb=this.GLOBAL.staticUrl+data.imgsrc;
	            	this.updatephoto.thumb=data.imgsrc;
	        	}
			    el.target.value = '';  
	        }
	     }).catch((res) => {
	        	
	     });
	},

	/** 新增品牌类型图片 **/
	addtemp() {
		var resource = this.$resource(this.url);
		resource.save(this.addphoto).then((res) => {
	    	if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	        	this.$message.success('添加品牌模板成功！');
				this.addphotoDialog=false;
				this.gettempbrands();
	        }
	    }).catch((res) => {
	        	
	    });
	},

	/** 编辑品牌图片信息 **/
	edit(item) {
		var resource = this.$resource(this.url);
        resource.save({ act:'geteditInfo',id: item.id,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                var result = JSON.parse(Base64.decode(res.data.Data));
				this.updatephoto.id=item.id;
				this.updatephoto.tempid=result.tempid;
				this.updatephoto.brandid=result.agentbrandid;
				this.updatephoto.thumb=result.thumb;
				this.updatephoto.showthumb=this.GLOBAL.staticUrl+result.thumb;
				this.updateDialog=true;
				this.size='';

            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
	},

	/** 保存修改的品牌图片信息 **/
	updatetemp() {
		var resource = this.$resource(this.url);
        resource.save(this.updatephoto).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                this.$message.success('保存修改品牌图片信息成功！');
				this.updateDialog=false;
				this.gettempbrands();
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
	},


	/** 删除品牌类型图片 **/
	del(item) {
		this.$confirm('您是否需要删除该品牌模板信息图片, 是否继续?', '提示', { type: 'warning' }).then(() => {
        	// 向请求服务端删除
            var resource = this.$resource(this.url);
            resource.save({ act:'delbrandtemp',id: item.id,token:this.$cookies.get('token')}).then((res) => {
            	if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                }else{
                    this.$message.success('删除品牌模板信息图片：' + item.tempname + '成功!');
                    this.gettempbrands();
                }
            }).catch((res) => {
            	this.$message.error(this.GLOBAL.errortext);
            });
        }).catch(() => {
        	
        });
	},






   } 
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/mall/Brandtemp.vue